import React, { useContext } from 'react';
import ConditionalSelectComponent from '../../../../common/components/ConditionalSelectComponent';
import { WindowSizeContext } from '../../../../common/context/WindowSizeContext';
import { getSelectedOption } from '../../../../common/utils';

export default function MustHaveTypeFilter({ filters, onFilterChange, overviewTableIsEmpty, toggleState }) {
    const windowSize = useContext(WindowSizeContext);

    let availableOptions = []
    let filterLabel = ''
    if (toggleState === 'innovation_product') {
        availableOptions = [
            { value: 'SM Eats', label: 'Innovations - SM Eats' },
            { value: 'Food To Go', label: 'Innovations - Food To Go' },
        ]
        filterLabel = 'Sub-Category'
    } else if (toggleState === 'must_have') {
        availableOptions = [
            { value: '888', label: 'Top 888' },
            { value: '4k', label: 'Top 4k' }
        ]
        filterLabel = 'Must-Have Type'
    }

    return (
        <>
            <ConditionalSelectComponent
                id="category-filter"
                labelId="category-filter-label"
                options={availableOptions}
                label={filterLabel}
                value={
                    filters && !Array.isArray(filters?.article_sub_category)
                        ? (windowSize.isOnMobile
                            ? filters?.article_sub_category
                            : getSelectedOption(filters?.article_sub_category, availableOptions))
                        : ''
                }
                onSelectChange={(event, newValue) => {
                    windowSize.isOnMobile ? onFilterChange('article_sub_category', event.target.value)
                        : onFilterChange('article_sub_category', newValue?.value)
                }}
                disableClearable={false}
                disabled={!filters?.store_id || overviewTableIsEmpty}
                endAdornment={true}
                startAdornment={false}
                clearSelected={() => onFilterChange('article_sub_category', null)}
            />
        </>
    );
}
